import { render } from "./edit.vue?vue&type=template&id=68b8bffd&scoped=true"
import script from "./edit.vue?vue&type=script&lang=js"
export * from "./edit.vue?vue&type=script&lang=js"

import "./edit.vue?vue&type=style&index=0&id=68b8bffd&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-68b8bffd"

export default script